<template>
  <div>
    <Search_stock/>
  </div>
</template>

<script>
import Search_stock from "@/components/adminArin/pos_system/warehouse/search_stock/Search_stock";
export default {
  name: "searchstock",
  components: {
    Search_stock
  }
}
</script>

<style scoped>

</style>
